<template>
  <svg
    width="14px"
    height="10px"
    viewBox="0 0 14 10"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>E-mail</title>
    <g
      id="FULL-Manage"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="wailist/register" transform="translate(-513.000000, -297.000000)">
        <g id="Group" transform="translate(392.000000, 249.000000)">
          <g id="user" transform="translate(48.000000, 0.000000)">
            <g id="icon/misc/email" transform="translate(72.000000, 45.000000)">
              <path
                d="M13.6666667,3.33333333 C14.2189514,3.33333333 14.6666667,3.78104858 14.6666667,4.33333333 L14.6666667,11.6666667 C14.6666667,12.2189514 14.2189514,12.6666667 13.6666667,12.6666667 L2.33333333,12.6666667 C1.78104858,12.6666667 1.33333333,12.2189514 1.33333333,11.6666667 L1.33333333,4.33333333 C1.33333333,3.78104858 1.78104858,3.33333333 2.33333333,3.33333333 L13.6666667,3.33333333 Z M9.26633333,8.22633333 L8,8.93779833 L6.84433333,8.28833333 L2.82433333,11.9993333 L13.4983333,11.9993333 L9.26633333,8.22633333 Z M1.99933333,5.56833333 L2,11.6666667 C2,11.7217308 2.01335163,11.7736764 2.03699406,11.8194428 L6.23333333,7.94533333 L1.99933333,5.56833333 Z M13.9993333,5.56933333 L9.88133333,7.88133333 L13.9993333,11.5523333 L13.9993333,5.56933333 Z M13.6666667,4 L2.33333333,4 C2.14923842,4 2,4.14923842 2,4.33333333 L1.99933333,4.80433333 L8,8.1732595 L13.9993333,4.80433333 L14,4.33333333 C14,4.14923842 13.8507616,4 13.6666667,4 Z"
                id="Combined-Shape"
                :fill="color"
              ></path>
              <path d="" id="Path-48" stroke="#979797"></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "Envelope",
  props: {
    color: {
      type: String,
      default() {
        return '#ABABAB';
      },
    },
  },
};
</script>

<style scoped>
</style>
